module.exports = __webpack_public_path__ + "img/homemid4.c45f6cd9.png";